import React from 'react';
import ReportingFoodAndBeverageToastSyncPage from '../components/ReportingFoodAndBeverageToastSyncPage';

const axios = require('axios').default;

const ReportingFoodAndBeverageToastSyncApp = (props) => {
  if (props.csrfToken) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = props.csrfToken;
  }
  return <ReportingFoodAndBeverageToastSyncPage {...props} />;
};

export default ReportingFoodAndBeverageToastSyncApp;
